import { GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';

export type KycApprovalStatus =
	| GetKYCInvestorInstanceRes['declarations'][0]['status']
	| 'PENDING' // default ui state, no action has been taken
	| 'WAITING' // used when kyc INVESTMENT_VEHICLE files are being waited for
	| null; // no underlying record yet (no file uploaded / no declarations submitted)

export type Step = {
	type: StepType;
	title: string;
	description: string;
	approvalStatus: KycApprovalStatus;
	isSelected: boolean; // if true, the step will be selected
	isDisplayed: boolean; // if true, the step will be displayed
	allowFileUpload?: boolean; // if true, the step will allow file upload
	allowMultipleFileUpload?: boolean; // if true, the step will allow multiple file uploads
};

export enum StepType {
	DECLARATIONS = 'DECLARATIONS',
	PROOF_OF_IDENTITY = 'PROOF_OF_IDENTITY',
	PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
	INVESTMENT_VEHICLE = 'INVESTMENT_VEHICLE',
	FORM = 'FORM',
}
